<template>
  <el-dialog
    :title="classType === 1 ? '选择面授班级' : '选择直播班级'"
    :visible.sync="dialogVisible"
    top="22vh"
    :modal="false"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <el-row>
      <el-col :span="12">
        <el-input size="small" v-model="searchName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" @click="search">搜索</el-button>
      </el-col>
    </el-row>

    <el-table
      ref="multipleTable"
      :data="tableDataCopy"
      height="300"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#d7d7d7' }"
      row-key="albumId"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="60"
        align="center"
        :reserve-selection="true"
      >
      </el-table-column>
      <el-table-column prop="batch" label="批次号/班级编码"> </el-table-column>
      <el-table-column prop="className" label="班级名称"> </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="comfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/TeacherClassroomManagement/MyClassroomTutorialsAndLive'
export default {
  props: ['classType', 'addType'],
  data() {
    return {
      dialogVisible: false,
      courseId: '',
      searchName: '',
      tableData: [],
      tableDataCopy: [],
      selectedList: [],
      isEchoTable: false,
      echoNum: 0,
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  methods: {
    async getBatchList(batchId) {
      const { data, code } = (
        await api.getBatchList({
          courseId: this.courseId,
          uid: this.getUId,
        })
      ).data
      if (code === 100000) {
        if (this.echoNum > 0) {
          this.$refs.multipleTable.clearSelection()
        }
        this.tableData = data
        this.tableDataCopy = data
        if (batchId) {
          if (this.addType !== 0 && !this.isEchoTable) {
            return data
          }
          if (this.isEchoTable && this.echoNum < 1) {
            this.echoNum++
            const arr = batchId.split(',')
            arr.forEach((item) => {
              const index = this.tableDataCopy.findIndex(
                (item2) => item2.batchId == item
              )

              this.$refs.multipleTable.toggleRowSelection(
                this.tableDataCopy[index],
                true
              )
            })
          }
        }
      }
    },
    search() {
      if (this.searchName.trim() === '')
        return (this.tableDataCopy = [...this.tableData])
      this.tableDataCopy = [
        this.tableData.find((item) => item.batch === this.searchName),
      ]
    },
    handleSelectionChange(arr) {
      this.selectedList = arr.sort((a, b) => a.albumId - b.albumId)
    },
    comfirm() {
      this.$emit('choseClasses', this.selectedList)
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  background-color: #d7d7d7;
}
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.el-table__header {
  .gutter {
    background-color: #d7d7d7;
  }
}
</style>